interface IconProps {
  fill?: string;
  circleFill?: string;
}
const NewLocationIcon = ({ fill, circleFill }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M5.6 14C8.4 11.2 11.2 8.694 11.2 5.6C11.2 2.506 8.694 0 5.6 0C2.506 0 0 2.506 0 5.6C0 8.694 2.8 11.2 5.6 14Z"
        fill={fill ?? '#015C9A'}
      />
      <circle cx="5.6" cy="5.6" r="2.1" fill={circleFill ?? '#FBFCFE'} />
    </svg>
  );
};

export default NewLocationIcon;
